(function () {
  'use strict';
  var CLS = 'ke014-subtotal';

  function parseMoneyParts(text) {
    text = String(text || '');
    var m = text.match(/([\d.,]+)/);
    if (!m) return null;
    var num = m[1];
    var prefix = text.slice(0, m.index);
    var suffix = text.slice(m.index + num.length);
    var decSep = '', intPart = num, decPart = '';
    var m2 = num.match(/^(.*?)([.,])(\d{1,2})$/);
    if (m2) { intPart = m2[1]; decSep = m2[2]; decPart = m2[3]; }
    var value = parseFloat(intPart.replace(/[.,\s]/g, '') + '.' + (decPart || '0'));
    if (isNaN(value)) return null;
    return {
      prefix: prefix, suffix: suffix, decSep: decSep,
      decimals: decSep ? decPart.length : 0,
      thouSep: decSep === ',' ? '.' : ',',
      value: value
    };
  }

  function formatMoneyLike(parts, value) {
    var s = value.toFixed(parts.decimals);
    var sp = s.split('.');
    var intFmt = sp[0].replace(/\B(?=(\d{3})+(?!\d))/g, parts.thouSep);
    return parts.prefix + intFmt + (parts.decimals ? parts.decSep + sp[1] : '') + parts.suffix;
  }

  function getQty() {
    var el = document.querySelector('.quantity-selector__input[name="quantity"]');
    var v = el ? parseInt(el.value, 10) : 1;
    return (v && v > 0) ? v : 1;
  }

  function update() {
    var row = document.querySelector('.' + CLS);
    var priceEl = document.getElementById('product_price');
    if (!row || !priceEl) return;
    var priceText = (priceEl.textContent || '').replace(/^\s+|\s+$/g, '');
    var qty = getQty();
    var out = priceText;
    if (qty > 1) {
      var parts = parseMoneyParts(priceText);
      if (parts) out = formatMoneyLike(parts, parts.value * qty);
    }
    row.querySelector('.' + CLS + '-price').textContent = out;
    row.querySelector('.' + CLS + '-qty').textContent = qty > 1 ? qty + ' \u00d7 ' + priceText : '';
  }

  function build() {
    if (document.querySelector('.' + CLS)) return true;
    var btn = document.querySelector('.product-personalization-content .p-personalization-button');
    var priceEl = document.getElementById('product_price');
    if (!btn || !priceEl || !btn.parentNode) return false;
    var row = document.createElement('div');
    row.className = CLS;
    row.innerHTML =
      '<span class="' + CLS + '-label">Zwischensumme:</span>' +
      '<span class="' + CLS + '-right">' +
        '<span class="' + CLS + '-price"></span>' +
        '<span class="' + CLS + '-qty"></span>' +
      '</span>';
    btn.parentNode.insertBefore(row, btn);
    update();
    if (window.MutationObserver) {
      new MutationObserver(update).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }
    ['input', 'change', 'click'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        var t = e.target;
        if (t && t.closest && t.closest('.quantity-selector__input[name="quantity"], .quantity-selector__button')) {
          setTimeout(update, 0);
        }
      }, true);
    });
    return true;
  }

  function arm() {
    if (build()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (build() || ++tries >= 20) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
  else arm();
})();
